export const biotechPaths = {
  root: {
    path: '',
  },
  home: {
    path: '/',
    getHref: () => '/',
  },
  // Dupe/alias of `home` above
  signIn: {
    path: '/',
    getHref: () => '/',
  },
  signUp: {
    path: '/sign-up',
    getHref: () => '/sign-up',
  },
  resetPassword: {
    path: '/reset-password',
    getHref: () => '/reset-password',
  },
  forgotPassword: {
    path: '/forgot-password',
    getHref: () => '/forgot-password',
  },
  dashboard: {
    root: {
      path: '/dashboard',
      getHref: () => '/dashboard',
    },
    overview: {
      path: '',
      getHref: () => '/dashboard',
    },
    patients: {
      path: 'patients',
      getHref: () => '/dashboard/patients',
    },
    targetPatients: {
      path: 'target-patients',
      getHref: () => '/dashboard/target-patients',
    },
    physicians: {
      path: 'physicians',
      getHref: () => '/dashboard/physicians',
    },
  },
};

export const paths = {
  root: {
    path: '',
  },
  home: {
    path: '/',
    getHref: () => '/',
  },
  // Dupe/alias of `home` above
  welcome: {
    path: '/',
    getHref: () => '/',
  },
  welcomeWithReferral: {
    path: '/referral',
    getHref: () => '/referral',
  },
  signIn: {
    path: '/sign-in',
    getHref: (redirectTo?: string | null | undefined) =>
      `/sign-in${
        redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''
      }`,
  },
  resetPassword: {
    path: '/reset-password',
    getHref: () => '/reset-password',
  },
  forgotPassword: {
    path: '/forgot-password',
    getHref: () => '/forgot-password',
  },
  verifyOtp: {
    path: '/verify-otp',
    getHref: () => '/verify-otp',
  },
  flow: {
    root: {
      path: '/:formResponseReferenceId',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}`,
    },
    previouslyDiagnosed: {
      root: {
        path: '/:formResponseReferenceId/previously-diagnosed',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/previously-diagnosed`,
      },
      start: {
        path: '',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/previously-diagnosed`,
      },
      addDiagnoses: {
        path: 'update',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/previously-diagnosed/update`,
      },
    },

    geneticHistory: {
      root: {
        path: '/:formResponseReferenceId/genetic-history',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history`,
      },
      start: {
        path: '',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history`,
      },
      tests: {
        path: 'tests',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history/tests`,
      },
      variants: {
        path: 'variants',
        getHref: (formResponseReferenceId: string) =>
          `/${formResponseReferenceId}/genetic-history/variants`,
      },
    },

    labTests: {
      path: '/:formResponseReferenceId/lab-tests',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/lab-tests`,
    },

    symptomAssessmentGate: {
      path: 'symptom-assessment-gate',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/symptom-assessment-gate`,
    },

    symptomAssessment: {
      path: 'symptom-assessment',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/symptom-assessment`,
    },

    fileUpload: {
      path: 'file-upload',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/file-upload`,
    },

    fewQuestions: {
      path: '/:formResponseReferenceId/few-questions',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/few-questions`,
    },

    trainerFewQuestions: {
      path: '/:formResponseReferenceId/trainer-few-questions',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/trainer-few-questions`,
    },
  },

  review: {
    root: {
      path: '/:formResponseReferenceId/review',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review`,
    },
    patientInfo: {
      path: '/:formResponseReferenceId/review/patient-info',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/patient-info`,
    },
    contactInfo: {
      path: '/:formResponseReferenceId/review/contact-info',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/contact-info`,
    },
    diagnoses: {
      path: '/:formResponseReferenceId/review/diagnoses',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/diagnoses`,
    },
    labTests: {
      path: '/:formResponseReferenceId/review/lab-tests',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/lab-tests`,
    },
    patientSymptoms: {
      path: '/:formResponseReferenceId/review/patient-symptoms',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/patient-symptoms`,
    },
    physicians: {
      path: '/:formResponseReferenceId/review/physicians',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/physicians`,
    },
    providerSignIn: {
      path: '/:formResponseReferenceId/review/provider-sign-in',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/provider-sign-in`,
    },
    processing: {
      path: '/:formResponseReferenceId/review/processing',
      getHref: (formResponseReferenceId: string) =>
        `/${formResponseReferenceId}/review/processing`,
    },
  },

  insurance: {
    root: {
      path: '/insurance',
      getHref: () => `/insurance`,
    },
    intake: {
      path: '/insurance',
      getHref: () => `/insurance`,
    },
    signIn: {
      path: '/insurance/sign-in',
      getHref: () => `/insurance/sign-in`,
    },
    process: {
      path: '/insurance/process',
      getHref: () => `/insurance/process`,
    },
    intro: {
      path: '/insurance/intro',
      getHref: () => `/insurance/intro`,
    },
    finalizeReferral: {
      path: '/insurance/finalize-referral',
      getHref: () => `/insurance/finalize-referral`,
    },
    missingData: {
      path: '/insurance/missing-data',
      getHref: () => '/insurance/missing-data',
    },
    duoTrio: {
      path: '/insurance/duo-trio',
      getHref: () => `/insurance/duo-trio`,
    },
    additionalTesting: {
      path: '/insurance/additional-testing',
      getHref: () => `/insurance/additional-testing`,
    },
    insuranceSign: {
      path: '/insurance/sign',
      getHref: () => `/insurance/sign`,
    },
    eligibilityResult: {
      path: '/insurance/:formResponseReferenceId/eligibility-result',
      getHref: (formResponseReferenceId: string) =>
        `/insurance/${formResponseReferenceId}/eligibility-result`,
    },
    previouslyDiagnosed: {
      root: {
        path: '/insurance/:formResponseReferenceId/previously-diagnosed',
        getHref: (formResponseReferenceId: string) =>
          `/insurance/${formResponseReferenceId}/previously-diagnosed`,
      },
      start: {
        path: '',
        getHref: (formResponseReferenceId: string) =>
          `/insurance/${formResponseReferenceId}/previously-diagnosed`,
      },
      addDiagnoses: {
        path: 'update',
        getHref: (formResponseReferenceId: string) =>
          `/insurance/${formResponseReferenceId}/previously-diagnosed/update`,
      },
    },
    complete: {
      path: '/insurance/complete',
      getHref: (formResponseReferenceId?: string) =>
        formResponseReferenceId
          ? `/insurance/complete?form_response_reference_id=${formResponseReferenceId}`
          : `/insurance/complete`,
    },
    reimbursement: {
      path: '/insurance/insurance_reimbursement',
      getHref: () => '/insurance/insurance_reimbursement',
    },
    sign: {
      path: '/insurance/sign',
      getHref: () => '/insurance/sign',
    },
  },

  trainer: {
    root: {
      path: '/trainer/:trainerType',
      getHref: (trainerType: string) => `/trainer/${trainerType}`,
    },
    signIn: {
      path: '/trainer/:trainerType/sign-in',
      getHref: (trainerType: string) => `/trainer/${trainerType}/sign-in`,
    },
    selector: {
      path: '/trainer/:trainerType/selector',
      getHref: (trainerType: string) => `/trainer/${trainerType}/selector`,
    },
    thankYou: {
      path: '/trainer/thank-you',
      getHref: () => `/trainer/thank-you`,
    },
    expiredLink: {
      path: '/trainer/expired-link',
      getHref: () => `/trainer/expired-link`,
    },
  },

  'not-found': {
    path: '/not-found',
    getHref: () => '/not-found',
  },

  dashboard: {
    root: {
      path: '/dashboard',
      getHref: () => '/dashboard',
    },
    status: {
      path: '',
      getHref: () => '/dashboard',
    },
    account: {
      path: 'account',
      getHref: () => '/dashboard/account',
    },
    relationshipToPatientUpdate: {
      path: ':formResponseReferenceId/symptom-assessment-gate',
      getHref: (formResponseReferenceId: string) =>
        `/dashboard/${formResponseReferenceId}/symptom-assessment-gate`,
    },
    patient: {
      path: 'patient',
      getHref: () => '/dashboard/patient',
    },
    fileUpload: {
      path: 'file-upload',
      getHref: () => '/dashboard/file-upload',
    },
    diagnoses: {
      path: 'diagnoses',
      getHref: () => '/dashboard/diagnoses',
    },
    geneticTests: {
      path: 'genetic-tests',
      getHref: () => '/dashboard/genetic-tests',
    },
    labTests: {
      path: 'lab-tests',
      getHref: () => '/dashboard/lab-tests',
    },
    assessment: {
      path: 'assessment',
      getHref: () => '/dashboard/assessment',
    },
    resources: {
      path: 'resources',
      getHref: () => '/dashboard/resources',
    },
    providerSignIn: {
      path: 'healthcare-connect/provider-sign-in',
      getHref: () => '/dashboard/healthcare-connect/provider-sign-in',
    },
    healthcareConnections: {
      path: 'healthcare-connect',
      getHref: () => '/dashboard/healthcare-connect',
    },
  },
} as const;
